import * as types from './action-types';
// import randomName from 'random-name';
import { random } from 'lodash';

export const CellState = (ascendancy) => ({
  name: '', //randomName(),
  birth: '', // + random(1700, 2016),
  death: '', // + random(1650, 2009),
  background: '#fff',
  textColor: '#333',
  inverted: false,
  ascendancy,
});

export function cellReducer(state = CellState(), {payload, type}) {
  switch (type) {
    case types.SET_NAME:
      return Object.assign({}, state, {
        name: payload,
      });

    case types.SET_BIRTH:
      return Object.assign({}, state, {
        birth: payload,
      });

    case types.SET_DEATH:
      return Object.assign({}, state, {
        death: payload,
      });

    case types.SET_BACKGROUND:
      return Object.assign({}, state, {
        background: payload,
      });
    
    case types.SET_TEXT_COLOR:
      return Object.assign({}, state, {
        textColor: payload,
      })
    
    case types.SET_BAND_COLOR:
      return Object.assign({}, state, {
        bandColor: payload,
      })

    case types.SET_PERSON_ID:
      return Object.assign({}, state, {
        personId: payload,
      })

    case types.SET_INVERTED:
      return Object.assign({}, state, {
        inverted: payload,
      })
    
    default: 
      return state;

  }
}


// WEBPACK FOOTER //
// ./src/core/cells/cell-reducer.js